export const GLOBAL_STATE = 'Payments'

export const STUDENT_PAYMENTS = 'STUDENT_PAYMENTS'
export const STUDENT_PAYMENTS_PRINCIPAL = 'STUDENT_PAYMENTS_PRINCIPAL'
export const STUDENT_PAYMENTS_BY_STUDENT = 'STUDENT_PAYMENTS_BY_STUDENT'
export const PAYMENTS_CREATE = 'PAYMENTS_CREATE'
